import React from "react";
import H2 from "@material-tailwind/react/Heading2";
import LeadText from '@material-tailwind/react/LeadText';
import H5 from "@material-tailwind/react/Heading5";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

function TechnicalCommittee() {
    return (
      <div className="container max-w-8xl relative mx-auto">
        <Helmet>
          <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Technical Committee</title>
        </Helmet>
        <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
            <li class="breadcrumb-item "><Link to="/scds2023/">Committee</Link></li>
            <li class="breadcrumb-item active" aria-current="page">TechnicalCommittee</li>
          </ol>
        </nav>
          <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center">
                  <H2 color="dark">Technical Committee</H2>
                  <div className="text-dark-200 text-dark-200 w-full mr-auto text-left" style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
                      <p>
                      {/* <b>Patron</b><br/>
                      Prof Datuk Ts. Dr. Hajah Roziah Mohd Janor<br/>
                      <i>Vice-Chancellor Universiti Teknologi MARA Malaysia</i><br/><br/> */}
                      
                      {/* <b>Advisor</b><br/>
                      Prof Ts. Dr Norazah Abd Rahman <br/>
                      <i>Universiti Teknologi MARA</i><br/>
                      Jasni Mohamad Zain<br/>
                      <i>Universiti Teknologi MARA</i><br/><br/> */}

                      {/* <b>Editorial</b><br/>
                      Marina Yusoff<br/>
                      <i>Universiti Teknologi MARA</i><br/>
                      Michael Berry<br/>	
                      <i>University of Tennessee, USA</i><br/>
                      Hai Tao<br/>				
                      <i>Baoji University of Arts and Sciences</i><br/>
                      Prof Azlinah Mohamed<br/>		
                      <i>Universiti Teknologi MARA</i><br/>
                      Murizah Kassim<br/>			
                      <i>Universiti Teknologi MARA</i><br/><br/> */}

                      <b>Conference Chair</b><br/>
                      Marina Yusoff<br/>
                      <i>Universiti Teknologi MARA</i><br/><br/>

                      <b>Co-Chair</b><br/>            
                      Hai Tao<br/>   
                      <i>Baoji University of Arts and Sciences</i><br/><br/>   

                      <b>Secretary</b><br/>  
                      Nurain Ibrahim (Head)<br/>   
                      <i>Universiti Teknologi MARA</i><br/>   
                      Siti Afiqah Muhamad Jamil<br/>               
                      <i>Universiti Teknologi MARA</i><br/><br/>      
                      
                      <b>Registration and Presentation</b><br/>  
                      Lu Ye<br/>
                      <i>Baoji University of Arts and Sciences</i><br/>  
                      Fang Xu<br/>
                      <i>Baoji University of Arts and Sciences</i><br/>  
                      Yang Xuelan<br/>
                      <i>Baoji University of Arts and Sciences</i><br/>  
                      Wan Fairos Wan Yaacob<br/>                                     
                      <i>Universiti Teknologi MARA</i><br/><br/>                      

                      <b>Finance Committee</b><br/> 
                      Nurbaizura Borhan (Head)<br/> 
                      <i>Universiti Teknologi MARA</i><br/>
                      Nur Asyikin Abdullah<br/>
                      <i>Universti Teknologi MARA</i><br/>
                      Azira Mohamed Amin<br/>
                      <i>Universti Teknologi MARA</i><br/><br/>

                      <b>Technical Program Committee</b><br/> 
                      Murizah Kassim (Head)<br/> 
                      <i>Universiti Teknologi MARA</i><br/>
                      Abdul Kadir Jumaat<br/>
                      <i>Universiti Teknologi MARA</i><br/>
                      Mohd Abdul Talib Mat Yusoh<br/> 
                      <i>Universiti Teknologi MARA</i><br/>
                      Nurain Ibrahim  <br/>
                      <i>Universiti Teknologi MARA</i><br/><br/>
                      
                      <b>Publicity & Sponsorship Committee</b><br/> 
                      Memiyanti Abdul Rahim (Head)<br/>
                      <i>Universiti Teknologi MARA</i><br/>
                      Nooritawati Md Tahir <br/>                                        
                      <i>Universiti Teknologi MARA</i><br/><br/>
                      
                      <b>Publication Committee (Program Book/Book of Abstracts)</b><br/> 
                      Siti Afiqah Muhamad Jamil (Head)<br/>
                      <i>Universiti Teknologi MARA</i><br/>
                      Mohammed Adam Kunna Azrag<br/>
                      <i>Universiti Teknologi MARA</i><br/>
                      Saiful Farik Mat Yatim<br/> 
                      <i>Universiti Teknologi MARA</i><br/>                              
                      Yang Xuelan<br/>
                      <i>Baoji University of Arts and Sciences</i><br/><br/>
   
                      <b>Website & Online Committee</b><br/> 
                      Mohamad Asyraf Abdul Latif <br/>
                      <i>Universiti Teknologi MARA</i><br/>
                      Muhamad Ridhwan Mohamad Razali <br/>
                      <i>Universiti Teknologi MARA</i><br/><br/>
                      
                      {/* <b>Montaj scds2023</b><br/>*/}

                      </p>
                  </div>
              </div>
          </div>

  </div>
    );
}

export default TechnicalCommittee;